import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { uiActions } from "../../store";
import styles from './PopUpModal.module.css';
import closeIcon from './assets/close.svg';

export default function PopUpModal({ handleClose, children }) {
    const dispatch = useDispatch();
    let ref = useRef();

    const handleCloseModal = function () {
        handleClose();
        dispatch(uiActions.setPopUpModalActive(false));
    };

    useEffect(() => {
        ref.current.showModal();
        dispatch(uiActions.setPopUpModalActive(true));
    }, [dispatch]);

    return (
        <dialog className={styles.container} ref={ref}>
            <button className={styles.closeModalIcon} onClick={handleCloseModal} aria-label="close Share Modal now">
                <img src={closeIcon} alt="close share modal icon" />
            </button>
            <div className={styles.contentMain}>
                {children}
            </div>
        </dialog>
    );
}
